module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1",
    attrs: {
      "id": "Ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "pg5"
    }
  }, [_c('b', [_vm._v("ACKNOWLEDGEMENTS")])])]), _c('a', {
    attrs: {
      "id": "pg5"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "pg5"
    }
  }, [_vm._v("The rich history of St. Charles has generated an equally rich collection of books, articles, photographs and festivals, many of which are mentioned here. It is impossible to cite or write about them all. I wish to thank the staff and volunteers at the St. Charles County Historical Society for their assistance in providing information and images. I also wish to thank Jim Karll at the O’Fallon Historical Society, Paul Huffman at Lindenwood University, Nick Fry at the St. Louis Mercantile Library at the University of Missouri–St. Louis, Jaime Bourassa at the Missouri History Museum, the staff of the State Historical Society of Missouri, Maria Leljedal at the U.S. Army Heritage and Education Center and Jim Steinhart at ")]), _c('a', {
    attrs: {
      "href": "http://TravelPhotoBase.com",
      "target": "_blank"
    }
  }, [_vm._v("TravelPhotoBase.com")]), _vm._v(". The historical reference section in the Kathryn Linnemann Library was also an invaluable resource. The Kirkwood Public Library and the Municipal Library Consortium of St. Louis County made requesting needed books a simple pleasure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Steven Clay gladly shared information about Charles Bentzoni with some guy who fired an e-mail to him from the void. A special thanks to Ann Hazelwood, one of the Main Street rehabilitation pioneers, who graciously provided me with documents and information about the development of the Main Street Historic District. I cannot forget my editor for the last five years, Ben Gibson, who gave me the opportunity to write yet another book for The History Press.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, how do I thank my wife, Vicki? She provided encouragement, information (she’s an author who has written about St. Charles, too), editing and all-around support. I guess all I can say is something I should say every day: Thank you.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bc40c2b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/acknowledgements.vue
// module id = 66
// module chunks = 0